import React from 'react';
import TextField from 'material-ui/TextField';
import { inject, observer } from 'mobx-react';

@inject('createTutorialStore')
@observer
export default class BaseInformation extends React.Component {

  handleChange = e => {
    this.props.createTutorialStore.handleChange({ [e.target.name]: e.target.value })
  };

  render() {
    let errors = this.props.createTutorialStore.errors;
    if (!errors)
      errors = {};
    return (
      <div>
        <div className="input-wrap main">
          <TextField
            onChange={this.handleChange}
            className='category-name'
            name="video_url"
            value={this.props.createTutorialStore.tutorial.video_url || ''}
            floatingLabelText="Video URL"
            errorText={errors.video_url}
            type="text"
          />
          <TextField
            onChange={this.handleChange}
            className='friendly-url'
            name="friendly_id_url"
            value={this.props.createTutorialStore.tutorial.friendly_id_url || ''}
            errorText={errors.friendly_id_url}
            floatingLabelText="Friendly URL(OPTIONAL)"
            type="text"
          />
        </div>
        <div className="input-wrap">
          <TextField
            onChange={this.handleChange}
            className='tutorial-title'
            name="title"
            value={this.props.createTutorialStore.tutorial.title || ''}
            errorText={errors.title}
            floatingLabelText="Tutorial Title"
            type="text"
          />
        </div>
        <div className="input-wrap">
          <TextField
            onChange={this.handleChange}
            className='tutorial-desc'
            name="description"
            errorText={errors.description}
            value={this.props.createTutorialStore.tutorial.description || ''}
            floatingLabelText="Tutorial Description (OPTIONAL)"
            type="text"
            multiLine={true}
            rows={1}
            rowsMax={4}
          />
        </div>
      </div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/blocks/tutorial_popup/BaseInformation.js